<style>
    .content-section {
        padding: 80px 0;
        background-color: #010137;
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
    }

    .content-wrapper {
        background: rgba(255, 255, 255, 0.9);
        padding: 40px;
        border-radius: 10px;
    }

    @media (max-width: 768px) {

        .content-wrapper {
            padding: 20px;
        }
    }

    .ban_sec {
        width: 100%;
    }

    .ban_img {
        width: 100%;
        position: relative;
    }

    .ban_img img {
        /* width: 100%; */
    }

    .ban_text {
        position: absolute;
        top: 50%;
        left: 6%;
        -ms-transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .ban_text strong {
        font: 800 52.22px/70px "Comfortaa";
        color: #fff;
    }

    .ban_text strong span {
        font: 400 40.44px/52px "Comfortaa";
        letter-spacing: 3px;
    }

    .ban_text p {
        font: 400 20px/30px "Comfortaa";
        color: #fff;
        margin: 7px 0 25px;
    }

    @media (min-width: 1200px) and (max-width: 1399px) {
        .ban_text p {
            font-size: 21px;
        }
    }

    .ban_text {
        position: absolute;
        top: 50%;
        left: 6%;
        transform: translateY(-50%);
        width: 60%;
    }

    @media (max-width: 991px) {
        .ban_text {
            width: 100%;
            left: 0;
            padding: 0 20px;
            text-align: center;
        }

        .ban_text strong,
        .ban_text p {
            margin: 0 auto;
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .ban_text p {
            font-size: 17px;
        }

        .ban_text strong {
            font-size: 50px;
            line-height: 60px;
        }

        .ban_text strong span {
            font-size: 37px;
        }

    }

    @media only screen and (max-width: 991px) {
        .ban_text strong {
            font-size: 35px;
            line-height: 40px;
        }

        .ban_text strong span {
            font-size: 28px;
            line-height: 35px;
            letter-spacing: 2px;
        }

        .ban_text p {
            font-size: 14px;
            line-height: 20px;
        }

    }

    .global_button img {
        width: 50px !important;
        height: auto;
    }

    @media only screen and (max-width: 767px) {
        .ban_img img {
            min-height: 290px;
            object-fit: cover;
        }
    }

    @media only screen and (max-width: 575px) {
        .ban_text strong {
            background: rgba(0, 0, 0, 0.8);
            padding: 2px;
            width: 100%;
            display: block;
        }
    }

    @media only screen and (max-width: 480px) {
        .ban_text strong span {
            font-size: 20px;
            line-height: 31px;
            letter-spacing: 1px;
        }

        .ban_text {
            left: 2%;
        }
    }

    .global_button:hover {
        color: transparent !important;
    }
</style>
<section class="ban_sec">

    <div class="ban_img">
        <div class="constellation-wrapper">
            <div id="particles-js"></div>
        </div>
        <img src="/assets/images/banners/new_home_banner.png" class="img img-responsive w-100 h-100 d-none d-md-block"
            width="100%" alt="home banner" />

        <img src="/assets/images/banners/new_home_banner.png" class="img img-responsive d-block d-md-none" width="100%"
            alt="home mobile" />
        <div class="container">
            <div class="ban_text">
                <strong>
                    The Future of Business Is Synchronized
                </strong>
                <p>We don’t just deliver technology—we orchestrate it.
                    By aligning your teams, data, and infrastructure, we give your business the agility to innovate
                    faster, scale smarter, and lead with confidence. </p>

                <div class="front-button   pt-lg-5 pt-2 mt-lg-2">
                    <a href="contact" class="global_button text-left text-white white_button"
                        aria-label="View Contact Page">
                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                alt="home screen button" /></div>
                        <span> TAKE THE BIG MOVE </span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</section>

<!------------Banner Slide Ends--------->
<!--====================  brand logo slider area ====================-->
<div class="brand-logo-slider-area section-space--ptb_60">
    <div class="trusted-global sixthheading text-center">Trusted by Global Clients</div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="brand-logo-slider__container-area">
                    <swiper-container class=" brand-logo-slider__container" slides-per-view="6" autoplay="true"
                        [autoplay]="{ delay: 9000 }" loop="true" [breakpoints]="swiperBreakpoints">
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="swiper-wrapper brand-logo-slider__one">
                                <div class="brand-logo__image">
                                    <img src="../../../assets/images/homepage/section_logos/futek.png" class="img-fluid"
                                        alt="section futek ">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="swiper-wrapper brand-logo-slider__one">
                                <div class="brand-logo__image">
                                    <img src="../../../assets/images/homepage/section_logos/apsvc-logo.png"
                                        class="img-fluid" alt="apsvclogo">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/ouropinions-logo.png"
                                    class="img-fluid" alt="ouropinionslogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/sarvani-logo.png"
                                    class="img-fluid" alt="swarvanilogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/curoRC-logo.png"
                                    class="img-fluid" alt="curorclogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class=" brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/newliscr-image.png"
                                    class="img-fluid" alt="liscrlogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class="brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/laqshya-logo.png"
                                    class="img-fluid" alt="laqshaylogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class="brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/new-movie-logo.png"
                                    class="img-fluid" alt="movemeasurelogo">
                            </div>
                        </swiper-slide>
                        <swiper-slide class="brand-logo brand-logo--slider">
                            <div class="brand-logo__image">
                                <img src="../../../assets/images/homepage/section_logos/k3ssportslogo.png"
                                    class="img-fluid" alt="k3sportslogo">
                            </div>
                        </swiper-slide>
                    </swiper-container>
                </div>
            </div>
        </div>
    </div>
</div>
<!------------Industry Logo Ends---->

<div class="content-section">
    <div class="container">
        <div class="content-wrapper">

            <div role="heading" aria-level="1" class="insight-title global_section_header"> From Fragmented to Fluid:
                Power Growth with Total Synchronization </div>

            <div class="insight-subcontent global_section_content px-0 pt-lg-3">Most businesses invest in digital
                transformation to gain speed, insight, and a competitive edge.</div>
            <div class="insight-subcontent global_section_content px-0 pt-lg-3"> But here’s what they often overlook:
                innovation doesn’t happen in silos. It happens when every part of your business—people, platforms, and
                data—moves in sync.</div>
            <div class="insight-subcontent global_section_content px-0 pt-lg-3">At Maganti IT, we engineer that
                synchronization. </div>
            <div class="insight-subcontent global_section_content px-0 pt-lg-3">We simplify complexity by aligning your
                cloud infrastructure, ERP systems, data flows, and core processes. Whether it’s modernizing legacy
                platforms, building custom e-commerce portals, or automating workflows end-to-end—we ensure every piece
                of your tech stack connects, scales, and performs as one. </div>
            <div class="insight-subcontent global_section_content px-0 pt-lg-3">Because the real ROI on transformation
                isn’t about how much tech you buy—
                It’s about how quickly your business can turn ideas into outcomes. </div>

            <div class="insight-subcontent global_section_content px-0 pt-lg-3">That’s traction. That’s velocity.
            </div>
            <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                That’s what we deliver. </div>
            <!-- <div class="front-button  col pt-lg-3 pt-3 mt-lg-2">
                    <a href="contact" class="global_button text-left col  "
                        aria-label="View Contact Page">
                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                alt="home screen button" /></div>
                        <span>Connect with our experts  </span>
                    </a>
                </div> -->

        </div>
    </div>
</div>
<!--======= Insights section Start =======-->
<div class="layouts-section-wrap">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 offset-sm-2 col-sm-8">
                <div class="pt-md-5" data-aos="fade-up">
                    <div class="insight-title global_section_header">
                        <div class="insight-title global_section_header" role="heading" aria-level="1">
                            Insights
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="-row d-lg-none pt-lg-4">
                <div class="px-4 -col-lg-12">
                    <div class="flexible-image-slider-wrap">
                        <swiper-container class="single-flexible__container " slides-per-view="1" autoplay="true"
                            loop="true">

                            <swiper-slide>
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider1.png"
                                        class="img img-responsive w-100 h-100 mt-2" alt="firstslider" />
                                    <div class="px-lg-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header px-0" role="heading"
                                            aria-level="1">
                                            <span role="heading" aria-level="1">The Future of Marketing Personalization:
                                                AI-Powered
                                                Journeys</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                                            <div>Across the entire customer journey, AI is assisting marketers in
                                                providing more helpful, enjoyable experiences for shoppers and improving
                                                performance. Find how retail stores can capitalize on this technology
                                                trend.</div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="personalize-and-machine-learning" class="global_button"
                                                aria-label="Read Personalize ML">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="machine learning" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider2.png"
                                        class="img img-responsive w-100 h-100 mt-2" alt="secondslider" />
                                    <div class="px-lg-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header px-0">
                                            <span>Embracing the next era of Digital: From Survival, Thriving to
                                                Reinvigorating</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                                            <div>Learn how businesses have progressed into the digital post-pandemic era
                                                and how far they can go to adapt to the changing customer mindset.</div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="/postpandamic" class="global_button"
                                                aria-label="Read Postpandamic Insights">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="post pandamic" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider3.png"
                                        class="img img-responsive w-100 h-100 mt-2" alt="thirdslider" />
                                    <div class="px-lg-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header px-0">
                                            <span>Drive digital adoption. Every minute. Every hour. Every day</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                                            <div>Increase software adoption and knowledge retention while making a
                                                positive impact on the working lives of your employees.</div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="migrate-cloud" class="global_button"
                                                aria-label="Read migrate cloud Insights">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="migratecloud" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper-container>
                    </div>
                </div>
            </div>
            <div>
                <app-insightsslider></app-insightsslider>
            </div>

        </div>
    </div>
    <!--======= Insights section Ends =======-->
    <!--======= Casestudy section Starts =======-->
    <div class="casestudy-layoutsection pt-lg-5">
        <div class=" container-fluid p-0">
            <div class="row">
                <div class="casestudy-mainsection col-12 offset-sm-2 col-sm-8" data-aos="fade-up">
                    <div class="casestudy_headder global_section_header my-3 mt-lg-4">Case Studies: Synchronization in
                        Action.</div>
                    <div class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 my-lg-3">

                        See how we’re helping businesses synchronize their technology for real-world impact—unlocking
                        efficiency, speed, and scalability.
                    </div>
                </div>
            </div>
            <div class="casestudy-layoutsection pt-lg-5">
                <div class=" container-fluid p-0">
                    <!------------------Carousel section starts------>
                    <div id="main-wrapper">
                        <div class="site-wrapper-reveal">
                            <div class="flexible-image-slider-wrapper">
                                <div class="container-fluid p-0">
                                    <div class="row m-0">
                                        <div class="col-lg-12 p-0">
                                            <div class="flexible-image-slider-wrap">
                                                <swiper-container id="homeCaseStudySwiper"
                                                    class=" single-flexible__container" slides-per-view="1"
                                                    navigation="true" loop="true">

                                                    <swiper-slide>
                                                        <div class="single-flexible-slider">

                                                            <img class="d-block img img-responsive w-100" alt="homepage"
                                                                src="../../../assets/images/homepage/caseStudyStory.png"
                                                                alt="casestudy button" />

                                                            <div class="overlay-text_case-studies h-100 w-100"
                                                                data-aos="fade-down">
                                                                <div class="row mx-0 h-75 supercharge">
                                                                    <div
                                                                        class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                        <div class="casestudy-bacground d-flex h-100 "
                                                                            style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd); height: 100% !important;">


                                                                            <div class=" px-md-4 m-auto text-center">
                                                                                <p class="text-white caseStudyTitle"
                                                                                    role="heading" aria-level="1">
                                                                                    Supercharge with Cloud and
                                                                                    Automation</p>
                                                                                <p
                                                                                    class="text-white global_section_content  casestudy-content-section">
                                                                                    FUTEK, a leading sensor technology
                                                                                    giant
                                                                                    takes the leap to cloud for a major
                                                                                    IT
                                                                                    transformation and innovation.
                                                                                </p>
                                                                                <a href="/futek-casestudy"
                                                                                    aria-label="Go to futek casestudy"
                                                                                    class="global_button  text-left col   white_button">
                                                                                    <div class="dub-arrow"><img
                                                                                            src="../../../assets/images/button/arrowWhite.png"
                                                                                            alt="arrow button" /></div>
                                                                                    READ CASE STUDY
                                                                                </a>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Single flexible slider End -->
                                                    </swiper-slide>
                                                    <swiper-slide>
                                                        <div class="single-flexible-slider">

                                                            <img class="d-block img img-responsive w-100" alt="homepage"
                                                                src="../../../assets/images/homepage/casestudy-ouropinions-image.png"
                                                                alt="our opinions" />

                                                            <div class="overlay-text_case-studies h-100 w-100"
                                                                data-aos="fade-up">
                                                                <div class="row mx-0 h-75  supercharge ">
                                                                    <div
                                                                        class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                        <div class="casestudy-bacground d-flex h-100"
                                                                            style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);">
                                                                            <div class=" px-md-4 m-auto text-center">
                                                                                <p class="text-white caseStudyTitle">
                                                                                    Helping exchange social perspectives
                                                                                    in a
                                                                                    seamless way </p>
                                                                                <p
                                                                                    class="text-white global_section_content  casestudy-content-section">
                                                                                    Learn how we built a futuristic
                                                                                    application
                                                                                    and incorporated future cloud
                                                                                    advances into
                                                                                    our client’s IT infrastructure.
                                                                                </p>
                                                                                <a href="/ouropinion-casestudy"
                                                                                    aria-label="Read Ouropinion Casestudy"
                                                                                    class="global_button  text-left col  text-white white_button">
                                                                                    <div class="dub-arrow"><img
                                                                                            src="../../../assets/images/button/arrowWhite.png"
                                                                                            alt="arrow button" /></div>
                                                                                    READ CASE STUDY
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Single flexible slider End -->
                                                    </swiper-slide>
                                                </swiper-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!------------------Carousel section Ends------>
                        <div class="industry-button text-center py-3 py-md-5">
                            <a href="/case-studies" aria-label="case-studies"
                                class="global_button d-none d-lg-inline-block text-left col ">
                                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                        alt="casestudies" /></div>
                                VIEW ALL
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--======= Casestudy section Ends =======-->
            <!--======= Manufacture section starts =======-->
            <section id="spotlight_section">

                <div class="pt-5" style="margin-bottom: 50px;">
                    <div class="section-title global_section_header" role="heading" aria-level="1">Solution Spotlight
                    </div>
                    <div
                        class="manufacture-subtitle global_sub_title vision-content-section text-center container mt-4">
                        Manufacturing thrives on precision—but fragmented systems create friction.We help manufacturers
                        eliminate operational drag by integrating production, planning, supply chain, and analytics into
                        one synchronized ecosystem- for Real-time visibility across operations, Smarter resource
                        allocation and improved revenue.
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row w-100 m-0">
                        <div class="col-md-6 col-12 p-0">

                            <img class="h-100 w-100" id="spotlight_img"
                                src="../../../assets/images/homepage/spotlight.png" alt="Manufacturing Expertisee" />
                        </div>
                        <div class="col-md-6 col-12 p-0">

                            <div class="solution_spotlight_div">
                                <div class="spotlight_content" role="heading" aria-level="1">
                                    <span class="p-lg-5  p-3 manufacture_title ">MANUFACTURING IT EXPERTISE</span>
                                    <div class="p-lg-5  p-3 manufacture_sub_title " role="heading" aria-level="1">
                                        Modernizing
                                        Manufacturing one process at a Time</div>
                                </div>
                                <ngx-slick-carousel class="spotlight_carousel">
                                    <div ngxSlickItem class="testimonial-slider__one wow move-up">
                                        <div class="testimonial-slider--info">
                                            <div class="text-center py-2 testimonial-slider__media">
                                                <img src="../../../assets/images/homepage/new-trnsform.png" width="100%"
                                                    alt="transform Slider" />
                                            </div>
                                            <div class="testimonial-slider__author">
                                                <div class="author-info">
                                                    <div class="name manufacturing-slide-name fifthheading px-3">
                                                        Smart Factory Integration</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testimonial-slider__text  manufacturing-content">
                                            Align IoT, automation, and AI-driven analytics for real-time visibility and
                                            predictive decision-making.
                                        </div>
                                    </div>
                                    <div ngxSlickItem class="testimonial-slider__one wow move-up">
                                        <div class="testimonial-slider--info ">
                                            <div class="text-center py-2">
                                                <img src="../../../assets/images/homepage/cloud.png" width="100%"
                                                    alt="Cloud Computing" />
                                            </div>
                                            <div class="testimonial-slider__author">
                                                <div class="author-info">
                                                    <div class="name manufacturing-slide-name fifthheading px-3">
                                                        Automated Workflows
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testimonial-slider__text  manufacturing-content">
                                            Eliminate inefficiencies by integrating robotics, machine learning, and
                                            AI-powered automation.
                                        </div>
                                    </div>
                                    <div ngxSlickItem class="testimonial-slider__one wow move-up">
                                        <div class="testimonial-slider--info ">
                                            <div class="text-center py-2">
                                                <img src="../../../assets/images/homepage/ai-image.png" width="100%"
                                                    alt="AI/ML Slider" />
                                            </div>
                                            <div class="testimonial-slider__author">
                                                <div class="author-info">
                                                    <div class="name manufacturing-slide-name fifthheading px-3">
                                                        Cloud-Powered Manufacturing
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testimonial-slider__text  manufacturing-content">
                                            Scale operations effortlessly with a fully connected, secure, and flexible
                                            cloud infrastructure.
                                        </div>
                                    </div>
                                    <div ngxSlickItem class="testimonial-slider__one wow move-up">
                                        <div class="testimonial-slider--info ">
                                            <div class="text-center py-2">
                                                <img src="../../../assets/images/homepage/analytics.png" width="100%"
                                                    alt="Analytics Slider" />
                                            </div>
                                            <div class="testimonial-slider__author">
                                                <div class="author-info">
                                                    <div class="name manufacturing-slide-name fifthheading px-3">
                                                        Supply Chain Synchronization</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testimonial-slider__text  manufacturing-content">
                                            Improve forecasting, optimize inventory, and reduce downtime with end-to-end
                                            visibility.

                                        </div>
                                    </div>
                                    <div ngxSlickItem class="testimonial-slider__one wow move-up">
                                        <div class="testimonial-slider--info ">
                                            <div class="text-center py-2">
                                                <img src="../../../assets/images/homepage/analytics.png" width="100%"
                                                    alt="Analytics Slider" />
                                            </div>
                                            <div class="testimonial-slider__author">
                                                <div class="author-info">
                                                    <div class="name manufacturing-slide-name fifthheading px-3">
                                                        Predictive Maintenance</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testimonial-slider__text  manufacturing-content">
                                            Prevent equipment failures before they happen with AI-driven insights and
                                            proactive alerts.

                                        </div>
                                    </div>
                                </ngx-slick-carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="industry-button text-center mt-5 py-md-5">
                <a href="/manufacturing" aria-label="View the Manufacturing page" class="global_button">
                    <div class="dub-arrow">
                        <img src="../../../assets/images/button/arrowBlack.png" alt="manufactureexplore" />
                    </div>
                    EXPLORE
                </a>
            </div>
            <!--======= Manufacture section Ends =======-->
            <!--------------Oracla Section starts------------>
            <section>
                <div class="oracle-mainsection">
                    <div class="oracle-section">
                        <div class="container-fluid p-0 h-100">
                            <div class="row h-100 m-0">

                                <div class="col-sm-12 p-0 col-md-3" data-aos="zoom-in"
                                    data-aos-anchor-placement="center-left">
                                    <img src="../../../assets/images/banners/prasad_ceo.jpg"
                                        class="img img-responsive w-100 h-100 d-md-block" width="100%"
                                        alt="prasadsir" />
                                </div>
                                <div class="col-sm-12 p-0 col-md-9" data-aos="zoom-in"
                                    data-aos-anchor-placement="center-right">
                                    <div style=" background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);"
                                        class="h-100">
                                        <div class="row -d-flex h-100">
                                            <div class="offset-1 col-11 -w-50">
                                                <div class="d-flex text_global">
                                                    <div class="pt-3">
                                                        <img src="../../../assets/images/homepage/technology-cap/qoute.png"
                                                            alt="quote" />

                                                        <div class=" quote_title global_section_header text-white pt-2">
                                                            We believe in customer-oriented business approach with a
                                                            high
                                                            quality of deliverables. With our unifying vision and team
                                                            work, we
                                                            are committed in building better community and better world.
                                                        </div>
                                                        <div class="quote_title global_section_content text-white pt-3">
                                                            <p style="font-weight: 600;">
                                                                <span>PRASAD MAGANTI - Founder</span>
                                                            </p>
                                                        </div>
                                                        <div class="pt-5 pb-2">
                                                            <a href="/journey" aria-label="View Our Journey"
                                                                class="global_button   text-left col text-white white_button">
                                                                <div class="dub-arrow"><img
                                                                        src="../../../assets/images/button/arrowWhite.png"
                                                                        alt="arrow button" /></div>
                                                                GET TO KNOW US
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!--------------Oracla Section ends------------>
            <!--------------Technology Section Ends------------>
            <section class="game-section">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="subSectionTitle global_section_header text-center">
                                Technology Capabilities
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-1 col-sm-12"></div>
                            <div class="col-md-10 col-sm-12">
                                <div
                                    class="technology-subtitle text-center global_sub_title vision-content-section mb-md-5 mt-5">
                                    <span>We help organizations move from disconnected tools to synchronized
                                        systems—across every layer of their digital operations. Our services are
                                        engineered for impact, agility, and measurable ROI.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div #carousel class="owl-carousel custom-carousel owl-theme" aria-label="Slide" data-aos="zoom-in">
                    <div class="item active techItem-cloud">
                        <div class="item-desc" role="button">
                            <div>Cloud Computing</div>
                            <p class="mt-3">Leap to the cloud and become future-ready</p>
                        </div>
                    </div>
                    <div class="item techitem-technology" role="button" aria-label="Technology Transformation">
                        <div class="item-desc">
                            <div>Technology Transformation</div>
                            <p class="mt-3">Co-create Business Transformation and Outperform Market Expectations
                            </p>
                        </div>
                    </div>
                    <div class="item techitem-artifical" role="button" aria-label="Artificial Intelligence">
                        <div class="item-desc">
                            <div>Artificial Intelligence</div>
                            <p class="mt-3">Integrate intelligent automated solutions for upgrading your business
                            </p>
                        </div>
                    </div>
                    <div class="item techitem-metaverse" role="button" aria-label="Metaverse">
                        <div class="item-desc">
                            <div>Metaverse</div>
                            <p class="mt-3">Wide spectrum of services across the entire Metaverse Continuum </p>
                        </div>
                    </div>
                    <div class="item active techItem-cloud" aria-label="Cloud Computing">
                        <div class="item-desc">
                            <div role="button">Cloud Computing</div>
                            <p class="mt-3">Leap to the cloud and become future-ready</p>
                        </div>
                    </div>
                    <div class="item techitem-technology" role="button" aria-label="Technology Transformation">
                        <div class="item-desc">
                            <div>Technology Transformation</div>
                            <p class="mt-3">Co-create Business Transformation and Outperform Market Expectations
                            </p>
                        </div>
                    </div>
                    <div class="item techitem-artifical" role="button" aria-label="Artificial Intelligence">
                        <div class="item-desc">
                            <div>Artificial Intelligence</div>
                            <p class="mt-3">Integrate intelligent automated solutions for upgrading your business
                            </p>
                        </div>
                    </div>
                    <div class="item techitem-metaverse" role="button" aria-label="Metaverse">
                        <div class="item-desc">
                            <div>Metaverse</div>
                            <p class="mt-3">Wide spectrum of services across the entire Metaverse Continuum </p>
                        </div>
                    </div>
                </div>
            </section>
            <!--------------Vision Section starts------------>
            <section>
                <div class="vision-section">
                    <div class="container-fluid pt-5 mt-4">
                        <div class="row">
                            <div class="col-lg-1 col-sm-12 col-md-12">
                            </div>
                            <div class="col-lg-5 col-sm-12 col-md-12" data-aos="zoom-in"
                                data-aos-anchor-placement="center-left">
                                <div class="subSectionTitle global_section_header">
                                    Let’s Build Your Synchronized Advantage
                                </div>
                                <!-- <div class="subSectionTitle global_section_header">
                                    Powered with Vision.
                                </div> -->
                                <div class=" vision-content-section global_sub_title pt-5 ps-2">
                                    Ready to see where synchronization can unlock value in your business?
                                    Let’s talk—our team will help you identify opportunities, eliminate bottlenecks, and
                                    design a clear path to scalable, synchronized growth.

                                </div>
                                <div class="front-button  col pt-lg-3 pt-3 mt-lg-2">
                                    <a href="contact" class="global_button text-left col  "
                                        aria-label="View Contact Page">
                                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                                alt="home screen button" /></div>
                                        <span>Connect with Our Experts </span>
                                    </a>
                                </div>

                            </div>
                            <div class="col-lg-6 col-sm-12 col-md-12 visionstyle" data-aos="zoom-in"
                                data-aos-anchor-placement="center-left">
                                <div class="cubeMainDiv">
                                    <div class="cubeTopFullImg">
                                        <div class="position-relative h-100 w-100">
                                            <a class="navigation_cube">
                                                <div class="position-absolute h-100 overflow-hidden">
                                                    <img class="h-100 w-100"
                                                        src="../../../assets/images/homepage/cube/new-cubeimage.png"
                                                        alt="cube internship" />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="cubeBottomLeftImg">
                                        <div class="position-relative h-100 w-100">
                                            <a href="/careers" class="navigation_cube" aria-label="View Careers Page">
                                                <div class="position-absolute h-100 overflow-hidden">
                                                    <img class="h-100 w-100"
                                                        src="../../../assets/images/homepage/cube/cube-1.png"
                                                        alt="cube contact" />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="cubeBottomRightImg">
                                        <div class="position-relative h-100 w-100">
                                            <a href="contact" class="navigation_cube" aria-label="View Contact Page">
                                                <div class="position-absolute h-100 overflow-hidden">
                                                    <img class="h-100 w-100"
                                                        src="../../../assets/images/homepage/cube/cube-2.png"
                                                        alt="cube team" />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="trained">
                    <div class="container-fluid ">
                        <div class="row" id="testimonials-logos">
                            <div class="col-12 text-center mb-4">
                                <div class="subSectionTitle global_section_header">
                                    Accreditations & Certifications
                                </div>
                                <div
                                    class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 my-lg-3">

                                    Our certifications reflect our commitment to security, performance, and innovation.
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-space-between">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/WBENC_Logo.png" class="img-fluid"
                                        alt="WBENC Logo">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/WOMEN_Logo.png" class="img-fluid"
                                        alt="WOMEN Logo">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/NMSDC_Logo.png" class="img-fluid"
                                        alt="NMSDC Logo">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/highly_Logo.png" class="img-fluid"
                                        alt="Highly Rated Logo">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/A+-Rating_Logo.png" class="img-fluid"
                                        alt="A+ Rating Logo">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/E-verify_Logo.png" class="img-fluid"
                                        alt="E-verify Logo">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mb-3">
                                <div class="logo">
                                    <img src="../../../assets/images/mit-mainpage/9001a.webp" class="img-fluid"
                                        alt="9001a Logo">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
            </section>